import type {RefObject} from 'react';
import type {FooterLeftActionProps} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import type {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';

export type AiPromptBoxUploadOption = ControlledListItemType & {keepDropdownOpenOnClick?: boolean};

export interface AiPromptBoxUploadsProps extends FooterLeftActionProps {
  renderAttachmentTooltip?: boolean;
  defaultTooltipText?: string;
  moreUploadsOptions?: AiPromptBoxUploadOption[];
  safeClickAreaRef?: RefObject<HTMLElement | null>;
  alignment?: ALIGNMENT_TYPE;
}

export enum AttachmentOptionType {
  FROM_DEVICE = 'fromdevice',
  CAPTURE = 'capture',
  MY_UPLOADS = 'myuploads',
  MY_DESIGN = 'mydesign',
  TEMPLATES = 'templates',
}
